import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('phx-loading-icon')
export class PhxLoadingIcon extends LitElement {
    static styles = css`
        :host {
            display: inline-block;
        }

        .dots {
            align-items: center;
            display: flex;
            justify-content: center;
        }

        .dot {
            animation: dotPulse 1s infinite alternate;
            background-color: currentColor;
            border-radius: 50%;
            height: 1em;
            margin: 0 0.4em;
            width: 1em;
        }

        .dot:nth-child(2) {
            animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
            animation-delay: 0.4s;
        }

        @keyframes dotPulse {
            0% {
                transform: scale(0.75);
            }
            100% {
                transform: scale(1.25);
            }
        }
    `;

    render() {
        return html`
            <div class="dots">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
        `;
    }
}
